import { AlgoliaSearchHit } from "@/services/algolia/types/search.types";
import {
    ResultListDefaultHit,
    ResultListHit,
    ResultListInjectedHit
} from "@/utils/search/types/internal/resultListHit";
import { ResultListHitType } from "@/utils/search/types/internal/resultListHitType.enum";

export const isHit = <THit>(
    hit: ResultListHit<AlgoliaSearchHit<THit>>
): hit is ResultListDefaultHit<AlgoliaSearchHit<THit>> => {
    return hit.type === ResultListHitType.HIT;
};

export const isInjected = <THit>(
    hit: ResultListHit<AlgoliaSearchHit<THit>>
): hit is ResultListInjectedHit => {
    return hit.type === ResultListHitType.INJECTED;
};
